<template>
  <div v-if="list && list[listIndex].logo">
    <van-overlay
      v-for="(item, index) in list"
      :key="index"
      z-index="999"
      :show="show[index]"
      @click="show[index] = false"
    >
      <div class="wrapper flex-col" @click.stop>
        <div class="flex items-center justify-center flex-col gap-[20px]">
          <div class="flex flex-col items-center justify-center">
            <img
              class="max-w-[400px] w-[80vw] mb-[20px]"
              v-lazy="item.logo"
              alt=""
              @click="handelUrl(item.href)"
            />
          </div>
          <van-icon
            size="26px"
            name="clear"
            class="text-[#ff0000] rounded-[50%]"
            @click="handelgb(index)"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
const show = ref({})
const listIndex = ref(0)
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})
watch(
  () => props.list,
  (newVal) => {
    newVal.forEach((item, index) => {
      show.value[index] = true
    })
  },
  {
    immediate: true
  }
)
const emits = defineEmits(['close'])
const handelgb = (i) => {
  show.value[i] = false
  if (i == props.list.length - 1) {
    emits('close')
  }
}
const handelUrl = (url) => {
  window.open(url, '_blank')
}
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
